import * as React from 'react';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { DataGrid,  GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { useOrderContext } from '../../components/Context/OrderContext';
import { useNavigate } from 'react-router-dom';

const columns = [
    {
        field: 'link',
        headerName: 'Link',
        width: 50,
        renderCell: (params) => (
            <i className="bi bi-info-circle"></i>
        ),
    },
    { field: 'orderNumber', headerName: 'Order Number', width: 150 },
    { field: 'branchName', headerName: 'Branch Name', width: 150 },
    { field: 'serviceDate', headerName: 'Service Date', width: 150 },  
    { field: 'serviceNames', headerName: 'Service', width: 150 },
    { field: 'totalAmount', headerName: 'Total Amount', width: 150 },
    { field: 'status', headerName: 'Status', width: 150 }
];

export default function OrderTable() {
    const { orders ,partnerOrders} = useOrderContext();
    const navigate = useNavigate();

    const handleRowClick = (params) => {
        // Navigate to the edit form with the branch ID
        navigate(`/vieworder/${params.id}`, { state: { branch: params.row } });
    };

    const handleAddBranch = () => {
        navigate('/newbranch');
    };

    const CustomToolbar = (props) => (
        <GridToolbarContainer>
        {/*    <EditToolbar {...props} />*/}
            <GridToolbar />
        </GridToolbarContainer>
    );
    function EditToolbar(props) {
        const { setRows, setRowModesModel } = props;

        const handleClick = () => {
            handleAddBranch();
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    New Branch
                </Button>
            </GridToolbarContainer>
        );
    }

    return (
        <main id="main" className="main">
            <div className="pagetitle">
            <h1>All Orders</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/admin">Home</a></li>
                        <li className="breadcrumb-item"><a href="/orders">Orders</a></li>
                        
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">


                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">

                                <h5 className="card-title"></h5>
                                {/* Tabs */}
                                <Box sx={{ width: '100%' }}>
                                    <AppBar position="static" color="default">
                                        {/* AppBar content can go here */}
                                    </AppBar>
                                  
                                </Box>

                                <div style={{ height: '100%', width: '100%' }}>
                                    <DataGrid
                                        getRowId={(row) => row.orderId}
                                        rows={orders}
                                        columns={columns}
                                        slots={{ toolbar: CustomToolbar }}
                                        onRowClick={handleRowClick} // Add this line to handle row clicks
                                        components={{ Toolbar: GridToolbar }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>
        </main>
    );
}
